(function() {
    'use strict';

    angular
        .module('app.archivoCCSS')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/archivo-grandes-contribuyentes',
                config: {
                    templateUrl: 'app/archivoCCSS/grandesContribuyentes.html',
                    controller: 'GrandesContribuyentes',
                    controllerAs: 'vm',
                    title: 'GrandesContribuyentes'
                }
            },
            {
                url: '/editar-grandes-contribuyentes/:anno/:mes/:id?',
                config: {
                    templateUrl: 'app/archivoCCSS/editarGrandesContribuyentes.html',
                    controller: 'EditarGrandesContribuyentes',
                    controllerAs: 'vm',
                    title: 'EditarGrandesContribuyentes'
                }
            }
        ];
    }
})();
